module.exports = __webpack_public_path__ + "static/media/diktat-22.fab65b41.mp3";